export default {
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      startBackground: "#ACC5FF",
      quizBackground: "#white",
      title: "Responde a 4 preguntas y recibe una clase gratuita para tu hijo/a de 8 a 17 años",
      subtitle: "Tu hijo/a podrá participar en la clase que prefiera",
      image: {
        url:  "/welcome/quiz_latam_checklist_custom_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      button: {
        text: "  Comenzar 🚀  ",
        style: {
          background: "#FFFFFF",
          color: "#18182E",
          "font-weight": "bold",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_latam_checklist_custom_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    successPage: {
      title: "¡Felicitaciones! 🎁",
      subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
    },
    quizRotateBySteps: {
      1: {
        question:
          "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
        answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
      },
      2: {
        question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
        answers: [
          "👍 No tiene conocimientos, debe estudiar lo básico",
          "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
          "🖥 Nivel intermedio, quiere profundizar conocimientos",
          "🕹 Usa los dispositivos más que nada para juegos",
        ],
      },
      3: {
        question:
          "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
        answers: [
          "🤔 Habilidades blandas",
          "🎓 Preparación para una carrera a futuro",
          "🖥 Actividades extracurriculares",
        ],
      },
      4: {
        question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
        answers: [
          "💻 Sí",
          {
            answer: "😐 No",
            stopAnswer: true
          },
        ],
      },
    },
  };